"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[469],{

/***/ 70469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ App; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./src/constant/index.tsx + 38 modules
var constant = __webpack_require__(17089);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(88116);
;// CONCATENATED MODULE: ./src/views/Home/WhatWeDoSection/MobileSlider/MobileSlider.tsx
// Import Swiper React components


// Import Swiper styles


// import required modules


function App() {
    var pagination = {
        clickable: true,
        renderBullet: function renderBullet(index, className) {
            return "<span class='".concat(className, " squish'></span>");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            pagination: pagination,
            modules: [
                swiper_esm/* Pagination */.tl
            ],
            className: "mySwiper h-full w-full mt-10",
            // loop={true}
            breakpoints: {
                600: {
                    slidesPerView: 2
                }
            },
            children: constant/* whatWeDoCategory.map */.Bv.map(function(param, i) {
                var description = param.description, image = param.image, title = param.title;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full flex items-center justify-center text-center pb-[70px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-[27px] pl-2 flex justify-center _whatWeDoMobileSliderFadeUpAnimation slider:delay-[0] slider:duration-[0] slider:translate-y-0 slider:opacity-100 delay-150 duration-500 translate-y-6 opacity-0",
                                    children: image
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "section-sub-title mb-[35px] _whatWeDoMobileSliderFadeUpAnimation slider:delay-[0] slider:duration-[0] slider:translate-y-0 slider:opacity-100 delay-200 duration-500 translate-y-6 opacity-0",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm leading-5 text-[#4A4A4A] max-w-[290px] _whatWeDoMobileSliderFadeUpAnimation slider:delay-[0] slider:duration-[0] slider:translate-y-0 slider:opacity-100 delay-[250msher] duration-500 translate-y-6 opacity-0",
                                    children: description
                                })
                            ]
                        })
                    })
                }, "hfshsfs_" + i);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/views/Home/WhatWeDoSection/MobileSlider/index.tsx




/***/ })

}]);